"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _auth = _interopRequireDefault(require("@aws-amplify/auth"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Fields = require("./Fields");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var RequireNewPassword = function RequireNewPassword(_ref) {
  var _ref$initialUsernameV = _ref.initialUsernameValue,
      initialUsernameValue = _ref$initialUsernameV === void 0 ? "" : _ref$initialUsernameV,
      onValueChange = _ref.onValueChange,
      onAuthStateChange = _ref.onAuthStateChange,
      _ref$customFields = _ref.customFields,
      customFields = _ref$customFields === void 0 ? {} : _ref$customFields,
      _ref$usernameField = _ref.usernameField,
      usernameField = _ref$usernameField === void 0 ? "email" : _ref$usernameField,
      _ref$order = _ref.order,
      order = _ref$order === void 0 ? ['username', 'password'] : _ref$order,
      authData = _ref.authData;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = _slicedToArray(_useState3, 2),
      passwordValue = _useState4[0],
      setPasswordValue = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      passwordValid = _useState6[0],
      setPasswordValid = _useState6[1];

  var _useState7 = (0, _react.useState)(initialUsernameValue),
      _useState8 = _slicedToArray(_useState7, 2),
      usernameValue = _useState8[0],
      setUsernameValue = _useState8[1];

  var _useState9 = (0, _react.useState)(!!initialUsernameValue),
      _useState10 = _slicedToArray(_useState9, 2),
      usernameValid = _useState10[0],
      setUsernameValid = _useState10[1];

  var _useState11 = (0, _react.useState)(Object.entries(customFields).reduce(function (acc, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, value.initialValue || ""));
  }, {})),
      _useState12 = _slicedToArray(_useState11, 2),
      customsValue = _useState12[0],
      setCustomsValue = _useState12[1];

  var _useState13 = (0, _react.useState)(Object.entries(customFields).reduce(function (acc, _ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        key = _ref5[0],
        value = _ref5[1];

    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, !!value.required ? false : true));
  }, {})),
      _useState14 = _slicedToArray(_useState13, 2),
      customsValid = _useState14[0],
      setCustomsValid = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = _slicedToArray(_useState15, 2),
      isValid = _useState16[0],
      setIsValid = _useState16[1];

  (0, _react.useEffect)(function () {
    onValueChange('password', passwordValue);
  }, [passwordValue]);
  (0, _react.useEffect)(function () {
    Object.entries(customsValue).forEach(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
          key = _ref7[0],
          value = _ref7[1];

      return onValueChange(key, value);
    });
  }, [JSON.stringify(customsValue)]);
  (0, _react.useEffect)(function () {
    setIsValid(passwordValid && usernameValid && Object.entries(customsValid).every(function (_ref8) {
      var _ref9 = _slicedToArray(_ref8, 2),
          key = _ref9[0],
          value = _ref9[1];

      return !!value || !order.includes(key);
    }));
  }, [usernameValid, passwordValid, JSON.stringify(customsValid), order.length]);
  (0, _react.useEffect)(function () {
    !!loading && _auth["default"].completeNewPassword(authData, passwordValue, customsValue).then(function (user) {
      return user.challengeName === 'SMS_MFA' || user.challengeName === 'SOFTWARE_TOKEN_MFA' ? Promise.resolve(onAuthStateChange("confirmsignin")).then(function () {
        return null;
      }) : user.challengeName === 'NEW_PASSWORD_REQUIRED' ? Promise.resolve(onAuthStateChange("requirenewpassword")).then(function () {
        return null;
      }) : user.challengeName === 'MFA_SETUP' ? Promise.resolve(onAuthStateChange("totpsetup")).then(function () {
        return null;
      }) : user.challengeName === 'CUSTOM_CHALLENGE' ? Promise.resolve(onAuthStateChange("customconfirmsignin")).then(function () {
        return null;
      }) : user;
    }).then(function (user) {
      return !user ? null : _auth["default"].verifiedContact(user);
    }).then(function (data) {
      return !data ? null : !!Object.keys(data.verified).length ? // IF THE USER HAS AT LEAST ONE METHOD OF CONTACT VERIFIED
      onAuthStateChange('signedin') : onAuthStateChange('verifycontact');
    })["catch"](console.log);
  }, [loading]);
  return /*#__PURE__*/_react["default"].createElement("form", {
    noValidate: true,
    autoComplete: "off"
  }, order.map(function (slug) {
    return slug === 'username' ? /*#__PURE__*/_react["default"].createElement(_Fields.UsernameField, {
      key: slug,
      disabled: !!initialUsernameValue,
      value: usernameValue,
      usernameField: usernameField,
      onValueChange: setUsernameValue,
      onValidChange: setUsernameValid,
      showValidators: false
    }) : slug === 'password' ? /*#__PURE__*/_react["default"].createElement(_Fields.PasswordField, {
      label: "New Password",
      key: slug,
      value: passwordValue,
      onValueChange: setPasswordValue,
      onValidChange: setPasswordValid,
      showValidators: true,
      helperText: /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "caption"
      }, "Enter your new password")
    }) : /*#__PURE__*/_react["default"].createElement(_Fields.CustomField, {
      key: slug,
      value: customsValue[slug],
      onValueChange: function onValueChange(value) {
        return setCustomsValue(_objectSpread(_objectSpread({}, customsValue), {}, _defineProperty({}, slug, value)));
      },
      onValidChange: function onValidChange(valid) {
        return setCustomsValid(_objectSpread(_objectSpread({}, customsValid), {}, _defineProperty({}, slug, valid)));
      },
      showValidators: true,
      customField: customFields[slug]
    });
  }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "contained",
    fullWidth: true,
    disabled: !isValid || !!loading,
    size: "large",
    onClick: function onClick() {
      return setLoading(true);
    },
    color: "secondary"
  }, "Change"), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    align: "center",
    variant: "overline"
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    onClick: function onClick() {
      return onAuthStateChange('signin');
    },
    color: "secondary",
    component: "a",
    variant: "overline"
  }, "Back to Signin")));
};

var _default = RequireNewPassword;
exports["default"] = _default;